import { render } from "./TiposContrato.vue?vue&type=template&id=18cee3a6"
import script from "./TiposContrato.vue?vue&type=script&lang=js"
export * from "./TiposContrato.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__